import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Button, Form, Modal, Divider, Row, Col } from '_zari/core'

import * as FormGroups from './formGroups'

import * as AsientosContablesService from 'services/asientosContables.service'

import { DownloadAxiosFile, ZrSwal } from 'utils'

const ImportarPresupuestoModal = ({ handleClose, show, reloadTable }) => {
  const __zariContext = React.useContext(ZariContext)
  const formInitialValues = React.useMemo(
    () => ({
      file: ''
    }),
    []
  )

  const submitHandler = data => {
    const submitData = new FormData()
    submitData.append('file', data.file)
    __zariContext.loader.open('Procesando excel')
    AsientosContablesService.importarPresupuesto(submitData)
      .then(() => {
        __zariContext.snack('success', 'Registros procesados correctamente.')
        reloadTable()
        handleClose()
      })
      .catch(({ data: { error } }) => {
        ZrSwal.showAlert({
          tipo: 'error',
          mensaje: (
            <>
              <span>Errores encontrados :</span> <br />
              {typeof error === 'string' ? (
                <>{error}</>
              ) : (
                error.map((x, k) => (
                  <React.Fragment key={k}>
                    <span>
                      {k + 1}. {x}
                    </span>{' '}
                    <br />
                  </React.Fragment>
                ))
              )}
            </>
          )
        })
      })
      .finally(() => {
        __zariContext.loader.close()
      })

    // .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }

  const clickDescargarPlantilla = React.useCallback(() => {
    AsientosContablesService.descargaPlantillaImportarPresupuesto().then(({ data, headers }) => {
      DownloadAxiosFile.downloadAsBlob(data, headers, 'Importar presupuesto.xlsx')
    })
  }, [])

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>IMPORTAR PRESUPUESTO</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler}>
        {({ errors, handleSubmit, isSubmitting, touched, setFieldValue }) => (
          <Form>
            <Modal.Body>
              <Row>
                <Col md={12}>
                  <Button outline block onClick={clickDescargarPlantilla}>
                    Descargar plantilla
                  </Button>
                </Col>
              </Row>
              <Divider />
              <FormGroups.FileFormGroup
                fIsSubmitting={isSubmitting}
                setFieldValue={setFieldValue}
                iError={errors.file}
                iTouched={touched.file}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit}>Importar</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default ImportarPresupuestoModal
